import { render, staticRenderFns } from "./DataSyncTimeline.vue?vue&type=template&id=12b43245"
import script from "./DataSyncTimeline.vue?vue&type=script&lang=ts"
export * from "./DataSyncTimeline.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports